// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XX6enMcaJ6jHKvCoqvmH{padding:12px}.Hl4qTSbaCOkSHAiXwVUt{min-width:492px}.Hl4qTSbaCOkSHAiXwVUt .Btguuy37NuTdg2JzjvLZ{padding:12px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/calling/ui/CompanyInfo/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CAGF,sBACE,eAAA,CAEA,4CACE,YAAA","sourcesContent":[".selectPadding {\n  padding: 12px;\n}\n\n.wrap {\n  min-width: 492px;\n\n  & .textField {\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectPadding": `XX6enMcaJ6jHKvCoqvmH`,
	"wrap": `Hl4qTSbaCOkSHAiXwVUt`,
	"textField": `Btguuy37NuTdg2JzjvLZ`
};
export default ___CSS_LOADER_EXPORT___;
